import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    InfoName,
    MarketInfoWrapper,
} from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/LegMarketInfo.style';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { BetLegType } from 'src/domains/sportsbook/betting/state/BetsListState';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

interface LegMarketInfoPropsType {
    leg: BetLegType;
    marketId: MarketId | null;
}

export const LegMarketInfo = observer('LegMarketInfo', ({ leg, marketId }: LegMarketInfoPropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);

    if (marketId === null) {
        return null;
    }

    const rawMarketName = leg.market?.name ?? null;
    const marketName = rawMarketName !== null && rawMarketName.trim() !== '' ? rawMarketName : null;

    const typeBet = leg.type;

    return (
        <MarketInfoWrapper>
            {marketName !== null && (
                <InfoName data-test='market-name'>
                    {languagesState.showMarketTranslation(marketId, marketName)}
                </InfoName>
            )}

            {typeBet !== 'rab' && <InfoName data-test='event-name'>{leg.event.name}</InfoName>}
        </MarketInfoWrapper>
    );
});
